// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global handorgel, google, langviken */

(function ($) {
  const wntrTheme = {
    body: $('body'),
    html: $('html'),
    document: $(document),
    current_position: 0,
    booking_start_date: false,
    booking_end_date: false,
    boat_upsell_seen: false,

    /**
     * Initialise theme JS on page load
     */
    init: function () {
      // Do we have JS?
      $('html').removeClass('no-js');

      // Automatically call all methods that start with __, in the order they're defined
      for (const prop in wntrTheme) {
        if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
          wntrTheme[prop].call();
        }
      }
    },

    /**
     * Preselect finland as country code in phone field
     */
    __preselectFi: function () {
      setTimeout(() => {
        const countries = wntrTheme.body.find('.iti__country[data-country-code=fi]');

        if (countries.length > 0) {
          $(countries[0]).trigger('click');
        }
      });
    },

    /**
     * Handle takeover/upsell modal
     */
    __handleTakeover: function () {
      const takeover = wntrTheme.body.find('#takeover');

      if (takeover.length > 0 && window.localStorage) {
        // Ensure user hasn't already seen this takeover
        const slug = 'takeover_' + takeover.data('slug');
        const takeoverSeen = localStorage.getItem(slug);

        if (takeoverSeen !== 'true') {
          setTimeout(function () {
            $.fancybox.open(takeover, {
              keyboard: false,
              clickSlide: false,
              clickOutside: false,
              touch: false,
            });

            // Hide modal content after form inside it is submitted
            wntrTheme.document.on('gform_confirmation_loaded', function (event, formId) {
              if (formId === parseInt(takeover.data('form'))) {
                takeover.find('.modal-content, .modal-terms').hide();
              }
            });

            localStorage.setItem(slug, true);
          }, parseInt(takeover.data('timeout')) * 1000);
        }
      }
    },

    /**
     * Validate arrival and departure date
     */
    __validateArrivalAndDepartureDate: () => {
      if (wntrTheme.body.find('#ferry__line')) {
        wntrTheme.body.on('change', '#ferry_line', function() {
          const ferry_line = $(this).val();
          const $product_time = wntrTheme.body.find('#product__time');
          const $time_of_arrival = wntrTheme.body.find('#time_of_arrival');
          const $time_of_departure = wntrTheme.body.find('#time_of_departure');

          wntrTheme.body.find('#ferry__line').removeClass('required');
          $time_of_arrival.find('option').remove();
          $time_of_departure.find('option').remove();

          if (ferry_line !== 'ferry-line') {
            if (ferry_line === 'tallink') {
              $time_of_arrival.append($('<option>', {
                value: '06:00',
                text: '06:00'
              }));
              $time_of_departure.append($('<option>', {
                value: '22:00',
                text: '22:00'
              }));
            } else {
              $time_of_arrival.append($('<option>', {
                value: '15:00',
                text: '15:00'
              }));
              $time_of_departure.append($('<option>', {
                value: '11:00',
                text: '11:00'
              }));
            }

            $product_time.addClass('active');
          } else {
            $product_time.removeClass('active');
          }
        });
      }

      if (wntrTheme.body.find('#product__time').length > 0) {
        const $time_wrapper = wntrTheme.body.find('#product__time');
        const $departure_time = wntrTheme.body.find('#time_of_departure');
        const fancybox_settings = {
          keyboard: false,
          clickSlide: false,
          clickOutside: false,
          touch: false,
        };

        wntrTheme.body.on('click', '.yith-wcbk-add-to-cart-button.single_add_to_cart_button', function (e) {
          if (wntrTheme.body.find('#product__time').is(':hidden')) {
            e.preventDefault();
            wntrTheme.body.find('#ferry__line').addClass('required');
            return;
          }

          wntrTheme.body.find('#ferry__line').removeClass('required');
          const departure_time = parseInt($departure_time.val().replace(':', ''));
          const start_date_input = wntrTheme.body.find('.yith-wcbk-booking-start-date');
          const end_date_input = wntrTheme.body.find('.yith-wcbk-booking-end-date');

          // The customer wants to leave later than 11:00, show time of departure notification
          if (departure_time > 1100) {
            e.preventDefault();

            const to = new Date(end_date_input.val());
            const initial_to = new Date(end_date_input.val());
            // Add one day to the "to" date
            to.setDate(to.getDate() + 1);

            // Check availability for the next day's date
            const data = {
              action: 'check_availability',
              data: {
                product: $time_wrapper.data('product'),
                from: start_date_input.val(),
                to: wntrTheme.formatDate(to),
              },
            };

            $.ajax({
              url: langviken.ajax_url,
              data: data,
              type: 'POST',
              dataType: 'json',
              success: function (response) {
                if (response.success) {
                  end_date_input.val(wntrTheme.formatDate(to));
                  wntrTheme.body.find('#extra_day_added').val('yes');

                  wntrTheme.body.find('#time_of_departure').find('option').remove();
                  wntrTheme.body.find('#time_of_departure').append($('<option>', {
                    value: '11:00',
                    text: '11:00'
                  }));
                  wntrTheme.body.find('#time_of_departure').val('11:00').trigger('change');

                  // Add a "fake" date only for visiblity
                  wntrTheme.body
                    .find('.yith-wcbk-date-range-picker')
                    .append(
                      '<span class="custom__time-of-departure-date">' + wntrTheme.formatDate(initial_to) + '</span>'
                    );
                  wntrTheme.body
                    .find('.product__time-of-departure')
                    .append('<span class="custom__time-of-departure">22:00</span>');

                  const modal = wntrTheme.body.find('#product__time-modal--success');
                  $.fancybox.open(modal, fancybox_settings);
                } else {
                  wntrTheme.body.find('#extra_day_added').val('no');
                  wntrTheme.body.find('.custom__time-of-departure-date').remove();
                  wntrTheme.body.find('.custom__time-of-departure').remove();

                  const modal = wntrTheme.body.find('#product__time-modal--fully-booked');
                  $.fancybox.open(modal, fancybox_settings);
                }
              },
              fail: function () {
                wntrTheme.body.find('#extra_day_added').val('no');
                wntrTheme.body.find('.custom__time-of-departure-date').remove();
                wntrTheme.body.find('.custom__time-of-departure').remove();

                const modal = wntrTheme.body.find('#product__time-modal--error');
                $.fancybox.open(modal, fancybox_settings);
              },
            });
          }
        });
      }

      wntrTheme.body.on('click', '.yith-wcbk-date-range-picker', function () {
        wntrTheme.body.find('.custom__time-of-departure-date').remove();
        wntrTheme.body.find('.custom__time-of-departure').remove();

        if (wntrTheme.body.find('#ferry_line').val() === 'tallink') {
          wntrTheme.body.find('#time_of_departure').find('option').remove();
          wntrTheme.body.find('#time_of_departure').append($('<option>', {
            value: '22:00',
            text: '22:00'
          }));
        }
      });

      wntrTheme.body.on('click', '#time_of_departure', function () {
        wntrTheme.body.find('.custom__time-of-departure-date').remove();
        wntrTheme.body.find('.custom__time-of-departure').remove();

        if (wntrTheme.body.find('#ferry_line').val() === 'tallink') {
          wntrTheme.body.find('#time_of_departure').find('option').remove();
          wntrTheme.body.find('#time_of_departure').append($('<option>', {
            value: '22:00',
            text: '22:00'
          }));
        }
      });

      wntrTheme.body.on('click', '.product__time-modal-close', function () {
        $.fancybox.close(true);
      });
    },

    formatDate: (date) => {
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }

      return [year, month, day].join('-');
    },

    /**
     * Handle boat upsell modal
     */
    __handleBoatUpsellModal: () => {
      wntrTheme.body.on(
        'click',
        '.woocommerce-cart-form__villa-collaterals-actions--missing-boat-products a',
        function (e) {
          if (!wntrTheme.boat_upsell_seen && wntrTheme.body.find('#boat-upsell__modal').length > 0) {
            e.preventDefault();
            $.fancybox.open($('#boat-upsell__modal'), {
              keyboard: false,
              clickSlide: false,
              clickOutside: false,
              touch: false,
              afterClose: function () {
                wntrTheme.boat_upsell_seen = true;
              },
            });
          }
        }
      );

      wntrTheme.body.on('click', '.boat-upsell__modal-action-add-boat', function () {
        $.fancybox.close(true);
        wntrTheme.boat_upsell_seen = true;

        setTimeout(function () {
          $('html, body').animate(
            {
              scrollTop: $('.woocommerce-cart__summary-upsell').offset().top - ($(window).width() >= 820 ? 20 : 80),
            },
            1000
          );
        }, 200);
      });
    },

    /**
     * Remove toggle from departure time description
     */
    __removeDepartureTimeToggle: () => {
      const $departure_time_desc = wntrTheme.body.find('#departure_time-description');
      if ($departure_time_desc.length > 0) {
        $departure_time_desc.removeClass('description');
      }
    },

    /**
     * Children product summary label
     */
    __childrenProductSummaryLabel: () => {
      const $product_summary = wntrTheme.body.find('.page-section-summary');
      if ($product_summary.length > 0) {
        wntrTheme.body
          .find('.yith-wcbk-form-section-person-types:nth-of-type(2) .yith-wcbk-booking-form__label')
          .text($product_summary.data('child-label'));
      }
    },

    /**
     * Disable autocomplete on datepickers
     */
    __disableDatepickerAutocomplete: () => {
      wntrTheme.body.find('input.datepicker').attr('autocomplete', 'off');
    },

    /**
     * Add spinner to coupon actions
     */
    __addSpinnerToCouponActions: () => {
      wntrTheme.body.find('.woocommerce-remove-custom-coupon, button[name=apply_coupon]').on('click', function () {
        wntrTheme.body.block({ message: null });
      });
    },

    /**
     * Toggle my account menu
     */
    __toggleMyAccountMenu: () => {
      wntrTheme.body.find('.woocommerce-MyAccount-navigation__toggle-btn').on('click', function () {
        wntrTheme.body.find('.woocommerce-MyAccount-navigation').slideToggle();
        $(this).toggleClass('is-active');
      });
    },

    /**
     * Handle deposit payments
     */
    __handleCustomDepositPayments: () => {
      wntrTheme.body.on('change', '.payment-deposit-options input[type=radio]', function () {
        const $rb = $(this);

        if ($rb.val() === 'full') {
          wntrTheme.body.find('#payment_method_stripe').prop('checked', true).closest('.wc_payment_method').show();
          wntrTheme.body.find('.payment__heading--wc_payment_methods').show();
        } else {
          wntrTheme.body.find('#payment_method_stripe').closest('.wc_payment_method').hide();
          wntrTheme.body.find('.payment__heading--wc_payment_methods').hide();
          wntrTheme.body.find('#payment_method_cheque').prop('checked', true);
        }
      });
    },

    /**
     * Init accordions
     */
    __initAccordions: () => {
      if (wntrTheme.body.find('.faq').length > 0) {
        $.each(wntrTheme.body.find('.faq'), function () {
          new handorgel($(this)[0]);
        });
      }

      if (wntrTheme.body.find('.accordion').length > 0) {
        $.each(wntrTheme.body.find('.accordion'), function () {
          new handorgel($(this)[0]);
        });
      }
    },

    /**
     * Scroll to booking component
     */
    __scrollToBookingComponent: () => {
      wntrTheme.body.find('.villa-banner__book-now button').on('click', function () {
        $('html, body').animate(
          {
            scrollTop: $('.product').offset().top,
          },
          750
        );
      });
    },

    /**
     * Add upsell product to booking
     */
    __addUpsellProductToBooking: () => {
      wntrTheme.body.find('.woocommerce-cart__summary-upsell input[type=checkbox]').on('change', function () {
        const $cb = $(this);
        wntrTheme.body.block({ message: null });

        if (!$cb.is(':checked')) {
          window.location = $cb.data('remove-url');
        } else {
          $cb.closest('form').trigger('submit');
        }
      });
    },

    /**
     * Slick sliders
     */
    __initSlickSliders: () => {
      const image_banner_slider = wntrTheme.body.find('.image-banner__carousel');
      if (image_banner_slider.length > 0) {
        image_banner_slider.slick({
          infinite: true,
          dots: false,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 4000,
          touchThreshold: 20,
          speed: 1500,
          pauseOnHover: false,
        });
      }

      const gallery_sliders = wntrTheme.body.find('.gallery__images, .image-gallery__images');
      if (gallery_sliders.length > 0) {
        gallery_sliders.on('init', function () {
          $(this)
            .find('.slick-dots')
            .append(
              '<li class="slick-num-of-slides" role="presentation"> / ' + gallery_sliders.data('slides') + '</li>'
            );
        });

        gallery_sliders.slick({
          infinite: true,
          dots: true,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 3000,
          touchThreshold: 20,
          speed: 1000,
        });
      }

      const villa_preview_sliders = wntrTheme.body.find('.villa-preview__slider .products');
      if (villa_preview_sliders.length > 0) {
        villa_preview_sliders.slick({
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 3.7,
          touchThreshold: 20,
          speed: 500,
          responsive: [
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 2.5,
              },
            },
            {
              breakpoint: 680,
              settings: {
                slidesToShow: 1.1,
              },
            },
          ],
        });
      }
    },

    /**
     * Check if mouse is used
     */
    __checkIfMouseIsUsed: () => {
      // Let the document know when the mouse is being used
      document.body.addEventListener('mousedown', function () {
        document.body.classList.add('using-mouse');
      });
      // Re-enable focus styling when Tab is pressed
      document.body.addEventListener('keydown', function (event) {
        if (event.keyCode === 9) {
          document.body.classList.remove('using-mouse');
        }
      });
    },

    /**
     * Toggle header background color on scroll
     */
    __toggleHeaderBackground: () => {
      let scrollTimeout = null;
      const throttle = 50;

      toggleHeaderBackgroundClass();

      // Simple scroll throttle
      $(window).on('scroll', function () {
        if (!scrollTimeout) {
          scrollTimeout = setTimeout(function () {
            toggleHeaderBackgroundClass();
            scrollTimeout = null;
          }, throttle);
        }
      });

      function toggleHeaderBackgroundClass() {
        const scroll_length = 15;
        const scroll = $(window).scrollTop();

        if (scroll >= scroll_length) {
          wntrTheme.body.addClass('header--solid');
        } else {
          wntrTheme.body.removeClass('header--solid');
        }
      }
    },

    /**
     * Toggle header
     */
    __toggleHeader: () => {
      // Toggle main header
      const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');

      toggleHeaderButton.on('click', function () {
        if (wntrTheme.body.hasClass('header--mobile-menu-active')) {
          wntrTheme.body.removeClass('header--mobile-menu-active');
          $(this).removeClass('is-active');

          //wntrTheme.body.removeClass('body--fixed');
          //wntrTheme.document.scrollTop(wntrTheme.current_position);
        } else {
          wntrTheme.body.addClass('header--mobile-menu-active');
          $(this).addClass('is-active');

          //wntrTheme.current_position = wntrTheme.document.scrollTop();
          //wntrTheme.body.addClass('body--fixed');
        }
      });
    },

    /**
     * Init Google Maps
     */
    __initGoogleMaps: function () {
      const map_wrapper = wntrTheme.body.find('.fishing-map__gmap');

      if (map_wrapper.length > 0) {
        $.each(map_wrapper, function () {
          const el = $(this);

          const map = new google.maps.Map(el[0], {
            zoom: 11,
            disableDefaultUI: true,
            center: new google.maps.LatLng(60.319054, 19.851726),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            gestureHandling: 'cooperative',
            styles: [
              {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#e9e9e9',
                  },
                  {
                    lightness: 17,
                  },
                ],
              },
              {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#f5f5f5',
                  },
                  {
                    lightness: 20,
                  },
                ],
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 17,
                  },
                ],
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 29,
                  },
                  {
                    weight: 0.2,
                  },
                ],
              },
              {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 18,
                  },
                ],
              },
              {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 16,
                  },
                ],
              },
              {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#f5f5f5',
                  },
                  {
                    lightness: 21,
                  },
                ],
              },
              {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#dedede',
                  },
                  {
                    lightness: 21,
                  },
                ],
              },
              {
                elementType: 'labels.text.stroke',
                stylers: [
                  {
                    visibility: 'on',
                  },
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 16,
                  },
                ],
              },
              {
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    saturation: 36,
                  },
                  {
                    color: '#333333',
                  },
                  {
                    lightness: 40,
                  },
                ],
              },
              {
                elementType: 'labels.icon',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#f2f2f2',
                  },
                  {
                    lightness: 19,
                  },
                ],
              },
              {
                featureType: 'administrative',
                elementType: 'geometry.fill',
                stylers: [
                  {
                    color: '#fefefe',
                  },
                  {
                    lightness: 20,
                  },
                ],
              },
              {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [
                  {
                    color: '#fefefe',
                  },
                  {
                    lightness: 17,
                  },
                  {
                    weight: 1.2,
                  },
                ],
              },
            ],
          });

          const infowindow = new google.maps.InfoWindow({
            content: '<div class="fishing-map__info-window"><h2>' + el.data('title') + '</h2></div>',
          });

          const marker = new google.maps.Marker({
            position: new google.maps.LatLng(60.319054, 19.851726),
            animation: google.maps.Animation.DROP,
            icon: {
              url: el.data('marker-url'),
              size: new google.maps.Size(36, 36),
            },
            map: map,
          });

          marker.addListener('click', function () {
            infowindow.open(map, marker);
          });

          // Define the LatLng coordinates for the polygon's path.
          const area_1 = [
            { lng: 19.7936, lat: 60.295989 },
            { lng: 19.78742, lat: 60.294288 },
            { lng: 19.788793, lat: 60.290885 },
            { lng: 19.784674, lat: 60.286801 },
            { lng: 19.777807, lat: 60.283057 },
            { lng: 19.772314, lat: 60.271142 },
            { lng: 19.768194, lat: 60.268758 },
            { lng: 19.767507, lat: 60.26399 },
            { lng: 19.771627, lat: 60.26365 },
            { lng: 19.778494, lat: 60.261947 },
            { lng: 19.78124, lat: 60.259562 },
            { lng: 19.810766, lat: 60.258881 },
            { lng: 19.808706, lat: 60.261606 },
            { lng: 19.809393, lat: 60.265353 },
            { lng: 19.822439, lat: 60.268418 },
            { lng: 19.823126, lat: 60.271823 },
            { lng: 19.812826, lat: 60.283057 },
            { lng: 19.812139, lat: 60.286801 },
            { lng: 19.8039, lat: 60.295989 },
            { lng: 19.79566, lat: 60.295989 },
          ];
          const area_2 = [
            { lng: 19.775572, lat: 60.367131 },
            { lng: 19.782266, lat: 60.36764 },
            { lng: 19.783811, lat: 60.372393 },
            { lng: 19.785871, lat: 60.375532 },
            { lng: 19.788274, lat: 60.377484 },
            { lng: 19.796514, lat: 60.37706 },
            { lng: 19.800291, lat: 60.377739 },
            { lng: 19.800977, lat: 60.381387 },
            { lng: 19.798231, lat: 60.384526 },
            { lng: 19.795313, lat: 60.385968 },
            { lng: 19.794454, lat: 60.388428 },
            { lng: 19.798059, lat: 60.389785 },
            { lng: 19.797029, lat: 60.395637 },
            { lng: 19.793081, lat: 60.395806 },
            { lng: 19.790334, lat: 60.39216 },
            { lng: 19.7857, lat: 60.391396 },
            { lng: 19.786558, lat: 60.389785 },
            { lng: 19.785185, lat: 60.387325 },
            { lng: 19.782953, lat: 60.384102 },
            { lng: 19.779691, lat: 60.382575 },
            { lng: 19.775572, lat: 60.383423 },
            { lng: 19.772653, lat: 60.380029 },
            { lng: 19.778661, lat: 60.375787 },
            { lng: 19.779005, lat: 60.372138 },
            { lng: 19.776179, lat: 60.367239 },
          ];
          const area_3 = [
            { lng: 19.911534, lat: 60.301138 },
            { lng: 19.911191, lat: 60.309727 },
            { lng: 19.914967, lat: 60.312023 },
            { lng: 19.918057, lat: 60.315083 },
            { lng: 19.922692, lat: 60.313808 },
            { lng: 19.928185, lat: 60.313893 },
            { lng: 19.931275, lat: 60.313213 },
            { lng: 19.935567, lat: 60.312108 },
            { lng: 19.93797, lat: 60.306411 },
            { lng: 19.938485, lat: 60.305561 },
            { lng: 19.940716, lat: 60.308282 },
            { lng: 19.944493, lat: 60.305561 },
            { lng: 19.945008, lat: 60.300968 },
            { lng: 19.946725, lat: 60.299352 },
            { lng: 19.948956, lat: 60.298502 },
            { lng: 19.94621, lat: 60.294079 },
            { lng: 19.939171, lat: 60.292803 },
            { lng: 19.931618, lat: 60.290846 },
            { lng: 19.929215, lat: 60.289059 },
            { lng: 19.92458, lat: 60.288123 },
            { lng: 19.920632, lat: 60.289229 },
            { lng: 19.918915, lat: 60.288549 },
            { lng: 19.917027, lat: 60.282763 },
            { lng: 19.914109, lat: 60.283018 },
            { lng: 19.914452, lat: 60.28489 },
            { lng: 19.914452, lat: 60.287187 },
            { lng: 19.912049, lat: 60.289229 },
            { lng: 19.911877, lat: 60.300883 },
          ];

          // Construct the polygon.
          const polygon_1 = new google.maps.Polygon({
            paths: area_1,
            strokeColor: '#28a745',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#28a745',
            fillOpacity: 0.35,
          });
          const polygon_2 = new google.maps.Polygon({
            paths: area_2,
            strokeColor: '#28a745',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#28a745',
            fillOpacity: 0.35,
          });
          const polygon_3 = new google.maps.Polygon({
            paths: area_3,
            strokeColor: '#28a745',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#28a745',
            fillOpacity: 0.35,
          });

          polygon_1.setMap(map);
          polygon_2.setMap(map);
          polygon_3.setMap(map);
        });
      }
    },
  };

  $(document).ready(wntrTheme.init);
})(jQuery);
